import { HTMLProps } from "react";
import { useAppStore } from "@/store/app";
import { cn } from "@/utils/helpers";
import Tooltip from "@/components/explorer/Tooltip";
import styles from "../Chart.module.css";


export interface ChartTooltipProps extends HTMLProps<HTMLElement> {
    x?: number;
    y?: number;
    year?: number;
    value?: number;
};

export default function ChartTooltip({
    x,
    y,
    year,
    value,
    className
} : ChartTooltipProps) {
    const controls = useAppStore(store => store.controls);

    return (
        <Tooltip
            x={x}
            y={y}
            show={Boolean(year)}
            view={controls.view}
            stat={controls.stat}
            value={value}
            title={year ? String(year) : null}
            className={cn(
				className,
				styles.ChartTooltip
			)}
        />
    )
};